import TextareaEditableField from 'src/components/fields/TextareaEditableField/TextareaEditableField';

export default TextareaEditableField;
